import { render } from "./GcpStatus.vue?vue&type=template&id=272e02b0&scoped=true"
import script from "./GcpStatus.vue?vue&type=script&lang=js"
export * from "./GcpStatus.vue?vue&type=script&lang=js"

import "./GcpStatus.vue?vue&type=style&index=0&id=272e02b0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-272e02b0"]])

export default __exports__